import { useCallback, useMemo, useState } from "react";
import { getComercialProjects } from "../../../../config";
import { getLastYears, highlight } from "../utils";

const leaderKey = "leader"

const useComercialTable = () => {
    const [leaders, setLeaders] = useState([])
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState()
    const [filteredInfo, setFilteredInfo] = useState({});


    const handleChange = (pagination, filters, sorter) => {
        setFilteredInfo(filters);
    };

    const clearFilters = () => {
        setFilteredInfo({})
    }

    const updateProjects = useCallback(({ name, date, teamAdmin, _id, description, status, clickupSpace }, text) => {
        const leader = teamAdmin.leaders.reduce((prev, current) => prev.concat(`${current.name} `), "");
        return {
            status,
            key: _id,
            clickupSpace,
            [leaderKey]: leader,
            name: highlight(name, text),
            description: highlight(description, text),
            year: new Date(date).getFullYear()
        }
    }, [])

    const updateData = useCallback(async (text) => {
        if (text === "") return;
        setLoading(true)
        try {
            const { payload } = await getComercialProjects(text);
            const { projects = [], leaders } = payload;
            setDataSource(projects.map(project => updateProjects(project, text)))
            const nameLeaders = new Set()
            leaders.forEach(leader => nameLeaders.add(leader.name))
            setLeaders([...nameLeaders].map(name => ({ value: name, text: name })))
        } finally {
            setLoading(false)
        }
    }, [updateProjects])


    const columns = useMemo(() => {
        return [
            {
                title: 'Nombre del proyecto',
                dataIndex: 'name',
                key: 'name',
                width: 200,
                render: htmlString => (
                    <span
                        dangerouslySetInnerHTML={{ __html: htmlString }}
                    />
                ),

            },
            {
                title: 'Descripción',
                dataIndex: 'description',
                key: 'description',
                render: htmlString => (
                    <span
                        dangerouslySetInnerHTML={{ __html: htmlString }}
                    />
                ),
            },
            {
                title: 'Líder de proyecto',
                dataIndex: leaderKey,
                key: leaderKey,
                filters: leaders,
                onFilter: (value, record) => record[leaderKey].indexOf(value) === 0,
                filteredValue: filteredInfo[leaderKey] || null,
                width: 200,
            },
            {
                title: 'Año',
                dataIndex: 'year',
                key: 'year',
                filters: getLastYears((new Date().getFullYear()) - 2010).map(value => ({ text: value, value })),
                onFilter: (value, record) => parseInt(record.year) === value,
                filteredValue: filteredInfo.year || null,
                width: 100
            },
            {
                title: 'Estatus',
                dataIndex: 'status',
                key: 'status',
                width: 200,
                sorter: (a, b) => {
                    console.log(a.status[0])
                    return a.status[0] <= b.status[0] ? -1 : 1
                },
            }, {
                title: "Ficha detalle",
                key: "action",
                render: (_, { clickupSpace }) => <div className="flex w-full justify-center">
                    <a target="_blank" rel="noreferrer" href={`${window.location.origin}/inmersys/project/${clickupSpace}`} className="w-10 bg-[#1876FF] py-1 px-2 rounded-md text-white  hover:cursor-pointer disabled:bg-gray-400" >Ver</a>
                </div>,
                width: 120,

            }

        ]
    }, [filteredInfo, leaders])

    return {
        columns,
        loading,
        dataSource,
        updateData,
        clearFilters,
        handleChange,
        areFilters: Object.keys(filteredInfo).length !== 0
    };
}

export default useComercialTable;